import React from "react";
import { Route, Routes } from "react-router-dom";

import NotFound from "~/components/NotFound/NotFound";
import { Studio } from "./Studio";

const StudioRouter = (): React.ReactElement => (
  <Routes>
    <Route index element={<Studio />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default StudioRouter;
